import React from "react";
import { useIntl } from "react-intl";

import styled from "styled-components";

import Card from "@components/Card";
import Div from "@components/Div";
import ErrorDialog from "@components/ErrorDialog";
import GDPRInformationMessage from "@components/privacyPolicies/GDPRInformationMessage";
import Section from "@components/Section";

import { useLogin } from "./Login.hooks";
import { useLoginSteps, useLoginRedirection } from "./hooks";

const StyledDiv = styled(Div)`
  @media (min-height: 720px) {
    margin-top: 5rem;
  }
`;

export const Login = () => {
  const { messages } = useIntl();
  const {
    bankIdLoginError,
    isLoginErrorDialogVisible,
    handleCloseErrorDialog,
  } = useLogin();
  useLoginRedirection();
  const { CurrentItem } = useLoginSteps();

  return (
    <Section
      p={[3, 3, 4, 4]}
      flex={1}
      display="flex"
      justifyContent="center"
      bg="var(--site-background-color)"
    >
      {isLoginErrorDialogVisible && (
        <ErrorDialog
          title={messages.label_bankID_login_failed}
          errorMessage={bankIdLoginError}
          onHide={handleCloseErrorDialog}
          onConfirm={handleCloseErrorDialog}
        />
      )}

      <Div
        flex={1}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
      >
        <StyledDiv
          display="flex"
          width={1}
          alignItems="center"
          justifyContent="center"
          marginTop="0rem !important"
          mb={4}
        >
          <Card width={1} maxWidth="464px">
            {CurrentItem}
          </Card>
        </StyledDiv>

        <GDPRInformationMessage />
      </Div>
    </Section>
  );
};

export default Login;
